import { Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { total, unused } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Contracts
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
            </CardActions>
        </Card>
    );
};

export default Component;
